"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
// import { DisplayComponent } from "./common/displayWrapper";
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_bootstrap_1 = require("react-bootstrap");
const hooks_1 = require("./hooks");
const UrlSchemaComponent = (props) => {
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const url = (props.schema.calc ? props.schema.calc(value) : value) || "";
    const modalQrCode = (0, hooks_1.useModalQrCode)();
    return (react_1.default.createElement(react_bootstrap_1.InputGroup, { className: "mb-3" },
        react_1.default.createElement(Form_1.default.Control, Object.assign({ type: "url", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), value: url }, registerProps)),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", style: { position: "relative" }, onClick: () => {
                modalQrCode({ value: url });
            } },
            react_1.default.createElement("i", { className: "mdi mdi-qrcode", onClick: () => { } })),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", style: { position: "relative" }, onClick: () => {
                window.open(url, "_blank");
            } },
            react_1.default.createElement("i", { className: "mdi mdi-link" })),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", style: { position: "relative" }, onClick: () => {
                navigator.clipboard.writeText(url);
            } },
            react_1.default.createElement("i", { className: "mdi mdi-content-copy" }))));
};
const UrlSchemaDisplayComponent = (props) => {
    const { value } = props;
    const url = (props.schema.calc ? props.schema.calc(value) : value) || "";
    const modalQrCode = (0, hooks_1.useModalQrCode)();
    return (react_1.default.createElement(react_bootstrap_1.InputGroup, { className: "mb-3" },
        react_1.default.createElement(Form_1.default.Control, { type: "url", className: (0, classnames_1.default)({}), value: url, readOnly: true }),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", style: { position: "relative" }, onClick: () => {
                modalQrCode({ value: url });
            } },
            react_1.default.createElement("i", { className: "mdi mdi-qrcode", onClick: () => { } })),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", style: { position: "relative" }, onClick: () => {
                window.open(url, "_blank");
            } },
            react_1.default.createElement("i", { className: "mdi mdi-link" })),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", style: { position: "relative" }, onClick: () => {
                navigator.clipboard.writeText(url);
            } },
            react_1.default.createElement("i", { className: "mdi mdi-content-copy" }))));
};
UrlSchemaComponent.display = UrlSchemaDisplayComponent;
exports.default = UrlSchemaComponent;
